
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class VepContainer extends Vue {
  @Prop() title: string;

  @Prop() subTitle: string;

  // Defaults to home route, override prop in parent component when needed.
  @Prop() routeBackTo?: string;
}
